module.exports = __webpack_public_path__ + "static/media/brownie.ae2056ec.png";